import { css } from '@/styled-system/css';

export const photoCarouselDotsStyles = css.raw({
  alignItems: 'center',
  backgroundColor: 'PhotoCarousel.Dots.bg.default',
  borderRadius: 'shape.capsule',
  insetBlockEnd: 'tighter',
  display: 'flex',
  flexDirection: 'row',
  gap: 'tighter',
  minHeight: 'indicator.xl',
  paddingBlock: 'micro.default',
  paddingInline: 'tightest',
  pointerEvents: 'none',
  position: 'absolute',
  insetInlineStart: '50%',
  transform: 'translateX(-50%)',
  zIndex: 5,

  _focusWithin: {
    backgroundColor: 'bg.action.impact.neutral.default',
    boxShadow: 'focus',
  },
});
